import React, { forwardRef } from 'react'
import MatrixMStickerBody from 'matrix-react-sdk/lib/components/views/messages/MStickerBody'

const MStickerBody = forwardRef((props, ref) => {
  const { mxEvent, replacingEventId } = props
  const isShadow = mxEvent.event.content.msgtype === 'g.shadow'
  return (
    <MatrixMStickerBody
      {...props} // eslint-disable-line react/jsx-props-no-spreading
      replacingEventId={isShadow ? null : replacingEventId}
      ref={ref}
    />
  )
})

export default MStickerBody
